import { mixinEditor } from '../../helpers/mixin';
import { EmbedService, NULL_EMBED_SERVICE } from '../../services/embed/embedService';
import { HtmlEditService, NULL_HTML_EDIT_SERVICE } from '../../services/html/htmlEditService';
import { HtmlService, NULL_HTML_SERVICE } from '../../services/html/htmlService';
import { ImageService, NULL_IMAGE_SERVICE } from '../../services/rich/imageService';
import { NULL_STYLE_SERVICE, StyleService } from '../../services/rich/styleService';
import { IndentService, NULL_INDENT_SERVICE } from '../../services/text/indentService';
import { LinkService, NULL_LINK_SERVICE } from '../../services/text/linkService';
import { ListService, NULL_LIST_SERVICE } from '../../services/text/listService';
import { NULL_QUOTE_SERVICE, QuoteService } from '../../services/text/quoteService';
import { BaseConnectingEditor } from '../base/connectingEditor';
import { BaseEditor } from '../base/editor';
import { RichEditor, RichEditorServices } from '../rich/richEditor';
import { TextEditor } from '../text/textEditor';

export interface HtmlEditor<S extends HtmlEditorServices = HtmlEditorServices>
  extends RichEditor<S>,
    HtmlEditorMixin<S> {}

export type HtmlEditorServices = RichEditorServices & {
  html: HtmlService;
  edit: HtmlEditService;
  style: StyleService;
  link: LinkService;
  indent: IndentService;
  quote: QuoteService;
  list: ListService;
  image: ImageService;
  embed: EmbedService;
};

export abstract class HtmlEditorMixin<S extends HtmlEditorServices> implements RichEditor<S> {
  abstract readonly services: S;

  get html() {
    return this.services.html.html;
  }

  get isActive() {
    return this.services.focus.isActive;
  }

  setDirtyHtml(html: string) {
    this.services.html.setDirtyHtml(html);
  }

  setCleanHtml(html: string) {
    this.services.html.setCleanHtml(html);
  }

  focus() {
    this.services.focus.focus();
  }

  blur() {
    this.services.focus.blur();
  }
}

export function createHtmlEditorFromTextEditor(editor: TextEditor): HtmlEditor {
  return new BaseHtmlEditor({
    services: {
      html: NULL_HTML_SERVICE,
      style: NULL_STYLE_SERVICE,
      link: NULL_LINK_SERVICE,
      indent: NULL_INDENT_SERVICE,
      quote: NULL_QUOTE_SERVICE,
      list: NULL_LIST_SERVICE,
      ...editor.services,
      edit: NULL_HTML_EDIT_SERVICE,
      image: NULL_IMAGE_SERVICE,
      embed: NULL_EMBED_SERVICE,
    },
  });
}

export class BaseHtmlEditor<S extends HtmlEditorServices> extends BaseEditor<S> implements HtmlEditor<S> {}
export interface BaseHtmlEditor<S extends HtmlEditorServices> extends HtmlEditorMixin<S> {}
mixinEditor(BaseHtmlEditor, HtmlEditorMixin);

export class BaseConnectingHtmlEditor<T, S extends HtmlEditorServices>
  extends BaseConnectingEditor<T, S>
  implements HtmlEditor<S> {}
export interface BaseConnectingHtmlEditor<T, S extends HtmlEditorServices> extends HtmlEditorMixin<S> {}
mixinEditor(BaseConnectingHtmlEditor, HtmlEditorMixin);
